import StyledChatToggleButtonBubbleContainer from '../../styles/StyledChatToggleButtonBubbleContainer';

interface ChatToggleButtonBubbleContainerProps {
  children: React.ReactNode;
}

const ChatToggleButtonBubbleContainer = ({ children }: ChatToggleButtonBubbleContainerProps) => {
  return (
    <StyledChatToggleButtonBubbleContainer>
      {children}
    </StyledChatToggleButtonBubbleContainer>
  );
};

export default ChatToggleButtonBubbleContainer;